import { render, staticRenderFns } from "./BidangUsaha.vue?vue&type=template&id=34b668a6&scoped=true&"
import script from "./BidangUsaha.vue?vue&type=script&lang=js&"
export * from "./BidangUsaha.vue?vue&type=script&lang=js&"
import style0 from "./BidangUsaha.vue?vue&type=style&index=0&id=34b668a6&scoped=true&lang=css&"
import style1 from "./BidangUsaha.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b668a6",
  null
  
)

export default component.exports